import { clientService } from "@features/Client/ClientService";
import { ClientOutputDTO } from "@features/Client/types";
import createEntitySlice from "@services/createEntitySlice";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Estendendo a interface EntityState para incluir o currentClientId
interface ExtendedClientState {
  items: ClientOutputDTO[];
  currentItem: ClientOutputDTO | null;
  loading: boolean;
  error: any;
  currentClientId: string | null;
}

// Slice para gerenciar entidades do Client
const {
  reducer: baseClientReducer,
  actions: clientActions,
  fetchAll: fetchClients,
  fetchById: fetchClientById,
  createEntity: createClient,
  updateEntity: updateClient,
  deleteEntity: deleteClient,
} = createEntitySlice<ClientOutputDTO>("client", clientService);

// Slice adicional para gerenciar o ID do formulário preenchido globalmente
const clientIdSlice = createSlice({
  name: "clientId",
  initialState: null as string | null,
  reducers: {
    setCurrentClientId: (_, action: PayloadAction<string>) => {
      return action.payload;
    },
    clearCurrentClientId: () => {
      return null;
    },
  },
});

// Combinar o reducer base com o novo reducer
const clientReducer = (state: any, action: any) => {
  // Inicializar o estado se for undefined
  if (state === undefined) {
    return {
      ...baseClientReducer(undefined, action),
      currentClientId: null,
    };
  }
  
  // Processar ações do clientIdSlice
  if (action.type === 'clientId/setCurrentClientId' || 
      action.type === 'clientId/clearCurrentClientId') {
    return {
      ...baseClientReducer(state, action),
      currentClientId: clientIdSlice.reducer(state.currentClientId, action),
    };
  }
  
  // Para outras ações, apenas usar o reducer base
  return {
    ...baseClientReducer(state, action),
    currentClientId: state?.currentClientId || null,
  };
};

// Exportar tudo
export {
  clientReducer,
  clientActions,
  fetchClients,
  fetchClientById,
  createClient,
  updateClient,
  deleteClient,
};

// Exportar as ações do novo slice
export const { setCurrentClientId, clearCurrentClientId } = clientIdSlice.actions;

// Exportar o tipo estendido
export type { ExtendedClientState };
